module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/menu-f0b4a11b039c5dfcb94fcbd85943450f.svg";